var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"filter_btn black--text my-3 mx-6 white--text",attrs:{"small":"","elevation":"0"},on:{"click":_vm.exportTable}},[_vm._v(" Exporter "),_c('v-icon',{staticClass:"primary--text"},[_vm._v("mdi-tray-arrow-up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }